import { createNamedContext } from '@core/createNamedContext'

// TODO: Temporary context for passing env until feature flagging system is setup

export type Env = 'local' | 'dev' | 'staging' | 'live'

export const EnvContext = createNamedContext<Env>('EnvContext', 'live')
